import { ExpandableResource } from '@shared/components/tree-data-table/expandable-resource';
import { FlatTreeControl } from '@angular/cdk/tree';

/** getParentNode
 * @param treeNodeControl FlatTreeControl
 * @param node TreeMatNode
 */
export const getParentNode = (
  treeNodeControl: FlatTreeControl<ExpandableResource<any>>,
  node: ExpandableResource<any>
): ExpandableResource<any> | any | null => {
  const currentLevel = treeNodeControl.getLevel(node);
  if (currentLevel < 1) {
    return null;
  }
  const startIndex = treeNodeControl.dataNodes.indexOf(node) - 1;
  for (let i = startIndex; i >= 0; i--) {
    const currentNode = treeNodeControl.dataNodes[i];
    if (treeNodeControl.getLevel(currentNode) < currentLevel) {
      return currentNode;
    }
  }
  return null;
};
